/*
view_bonus
*/
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import viewSubmitbtn from './view-submitbtn.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';
import notifications from '../../../notifications.js'; // better use the one in commonview
import {
	push
} from './../../../store/history.js';

let textkeysObj = {};
let elements = {
	wrap: null,
	form: null,
	wrapmethods: null,
	select: null,
	bonuses: [],
	bonusesref: {},
	nextbtn: null,
	nextbtnwrap: null,
	assembled: false
};
let callbackOnConfirm;
const classSelect = 'bonus--is-selected';
const classUnselect = 'bonus--is-unselected';
const nodetree = core.nodetree;
const create = core.create; // create elements that can be inserted into the dom
const needsMobVerErrCode = 'BONUS_ADD_NEEDS_VERIFIED_MOBILE';
// const needsEmailVerErrCode = 'BONUS_ADD_NEEDS_VERIFIED_EMAIL';

function createContentWrap() {
	return create({
		type: 'main',
		class: 'payment__content-wrapper grid-r content'
	});
}

function createBonus(bonusid) {
	return create({
		type: 'figure',
		class: 'js-event-filter js-bonus shop-item bonus u-m0 grid-u-sm-1-2 grid-u-md-1-4',
		bonusid
	});
}

function createBonusLink() {
	return create({
		type: 'div',
		class: 'shop-item-aspect-ratio'
	});
}

function createBonusImagewrapper() {
	return create({
		type: 'div',
		class: 'aspect-ratio__content shop-item__image-wrapper u-b-radius'
	});
}

function createBonusImagewrapperInner() {
	return create({
		type: 'a',
		href: '#',
		class: 'checkmark-wrapper u-p2'
	});
}

function createBonusTextwrapper(descr, txt) {
	const bonusTextWrapper = create({
		type: 'figcaption',
		class: 'shop-item__caption u-p1 u-relative u-box-bg u-b-radius-bottom'
	});
	const info = create({
		type: 'div',
		class: 'bonus__info-wrap u-hide'
	});
	const descriptionElm = create({
		type: 'h4',
		class: 'bonus__info-description'
	});
	const textElm = create({
		type: 'p',
		class: 'bonus__info-text'
	});
	textElm.innerHTML = txt;
	descriptionElm.innerHTML = descr;
	info.appendChild(descriptionElm);
	info.appendChild(textElm);
	bonusTextWrapper.appendChild(info);
	return bonusTextWrapper;
}

function createBonustypeTitle(txt) {
	const elm = create({
		type: 'small',
		class: 'support-title'
	});
	elm.innerHTML = txt;
	return elm;
}

function createMaintitle(txt) {
	const elm = create({
		type: 'h2',
		class: 'main-title u-m0' /*  to remove text that don't fit the box use : u-truncate */
	});
	elm.innerHTML = txt;
	return elm;
}

function createBonusImage(url) {
	return create({
		type: 'img',
		class: 'shop-item__image u-div-c',
		src: url
	});
}

function createCheckmarkWrapper() {
	let pathIconCheck;
	let svg;
	try {
		pathIconCheck = create({
			type: 'path',
			d: 'M12.28 21.56C11.04 21.57 9.81 21.32 8.67 20.83 3.95 18.84 1.74 13.4 3.73 8.67 5.73 3.95 11.17 1.74 15.89 3.73 16.44 3.97 16.97 4.26 17.47 4.6 17.65 4.72 17.7 4.97 17.58 5.15 17.45 5.33 17.2 5.38 17.02 5.26 16.56 4.95 16.08 4.68 15.57 4.47 13.47 3.58 11.1 3.58 9 4.47 5.85 5.79 3.81 8.87 3.81 12.28 3.81 15.69 5.85 18.77 9 20.09 11.1 20.98 13.47 20.98 15.57 20.09 17.61 19.22 19.23 17.6 20.1 15.57 20.54 14.53 20.76 13.42 20.75 12.29 20.76 11.55 20.66 10.8 20.47 10.08 20.41 9.87 20.53 9.66 20.74 9.6 20.95 9.54 21.17 9.66 21.23 9.87 21.44 10.66 21.55 11.47 21.55 12.29 21.56 13.53 21.31 14.76 20.82 15.9 19.88 18.12 18.11 19.89 15.88 20.84 14.74 21.32 13.52 21.57 12.28 21.56ZM12.09 15.63C11.87 15.63 11.66 15.53 11.52 15.36L7.8 11.08C7.67 10.92 7.69 10.68 7.84 10.54 7.99 10.4 8.23 10.4 8.38 10.54L8.38 10.56 12.09 14.84 20.34 5.38C20.49 5.21 20.74 5.2 20.91 5.34 21.07 5.49 21.09 5.74 20.94 5.9L12.66 15.37C12.52 15.53 12.31 15.63 12.09 15.63Z' // eslint-disable-line max-len
		});
		svg = create({
			type: 'svg',
			class: 'checkmark-wrapper__checkmark u-pos-c',
			viewBox: '0 0 24 24'
		});
		svg.appendChild(pathIconCheck);
	} catch (err) {
		console.warn('payments/view_bonus:createCheckmarkWrapper', err);
	}
	return svg;
}

function createOffertag() {
	let offertag;
	let pathIconHeart;
	let svg;
	try {
		pathIconHeart = create({
			type: 'path',
			class: 'icon__heart',
			d: 'M29.68 54.92q-2.69-1.8-7.6-5.6a63.17 63.17 0 0 1-9.25-8.86A41 41 0 0 1 6 29.55a15.15 15.15 0 0 1-.18-11.73 14.89 14.89 0 0 1 4.67-6.28 14.46 14.46 0 0 1 7.18-3.05q0.48-.06 1-0.09l1 0a14.57 14.57 0 0 1 11.55 5.57 12.87 12.87 0 0 1 1.17 1.77 14.53 14.53 0 0 1 .87 1.89 11.7 11.7 0 0 1 .39 1.29q0.15 0.63.27 1.23a0.49 0.49 0 0 0 0 .15 3.11 3.11 0 0 0 .15.33 1.27 1.27 0 0 0 .48.54 1.26 1.26 0 0 0 .66.18 1.42 1.42 0 0 0 .69-0.18 1.18 1.18 0 0 0 .51-0.6 4.19 4.19 0 0 0 .06-0.69V19.19q-0.12-.78-0.3-1.56a11.6 11.6 0 0 0-.48-1.56l-0.36-.84L35 14.4a2.22 2.22 0 0 1-.3-1.5 2.44 2.44 0 0 1 .72-1.38h0.06a13.9 13.9 0 0 1 4.25-2.36 14.72 14.72 0 0 1 4.85-.81 8.45 8.45 0 0 1 1 .06l1 0.12a14.06 14.06 0 0 1 7.07 3.05 14.63 14.63 0 0 1 4.55 6.28A15.42 15.42 0 0 1 58 29.61 39.61 39.61 0 0 1 51.17 40.5a66.12 66.12 0 0 1-9.25 8.83q-4.88 3.8-7.57 5.6a3.41 3.41 0 0 1-1.08.54 4.49 4.49 0 0 1-2.51 0A3.41 3.41 0 0 1 29.68 54.92Z' // eslint-disable-line max-len
		});
		svg = create({
			type: 'svg',
			class: 'bonus__svg-offer-tag u-dib',
			viewBox: '0 0 64 64'
		});
		offertag = create({
			type: 'div',
			class: 'bonus__offer-tag offer-tag u-box-bg u-pos-c u-text-c u-b-radius-round'
		});
		svg.appendChild(pathIconHeart);
		offertag.appendChild(svg);
	} catch (err) {
		console.warn('payments/view_bonus:createOffertag', err);
	}
	return offertag;
}

function createWrapSubmit() {
	return create({
		type: 'div',
		class: 'u-btn-wrapper u-absolute u-pos-bl0 grid-u-sm-1'
	});
}

function createHiddenPaymentMethodsField(paymentMethods) {
	const elm = create({
		type: 'hidden',
		class: 'payment-methods',
		value: paymentMethods
	});
	return elm;
}

function toggleSelectClass(id) {
	Object.keys(elements.bonusesref).forEach((key) => {
		if (id === -1) {
			/* nor classUnselect or classSelect should be present when nothing is selected */
			core.removeClass(elements.bonusesref[key], classSelect);
			core.removeClass(elements.bonusesref[key], classUnselect);
		} else if (id !== -1 && id.toString() === key) {
			/* select */
			core.removeClass(elements.bonusesref[key], classUnselect);
			core.addClass(elements.bonusesref[key], classSelect);
		} else if (id !== -1 && id.toString() !== key) {
			/* deselect */
			core.addClass(elements.bonusesref[key], classUnselect);
			core.removeClass(elements.bonusesref[key], classSelect);
		}
	});
}

function handleBonusRedeemFailure(data, bonusId) {
	if (data.errorCode === needsMobVerErrCode) {
		const pushToMobileVerify = function pushToMobileVerify() {
			const referrer = (location && location.search && location.search.indexOf('register') !== -1 ? 'register' : 'deposit');
			let referrerUrl;
			if (location && location.pathname) {
				referrerUrl = location.pathname;
			}
			push('/account/mysettings/verify-mobile/', { bonusId, referrer, referrerUrl });
		};

		notifications.showBinaryQuestion(data.errorDescription, textkeysObj['verify-mobile'], textkeysObj['not-now'], pushToMobileVerify, notifications.hideNotification);
	} else {
		notifications.showNotification(data.errorDescription, 'red', true);
	}
	console.error(`view-bonus:230:FAILURE:${data.errorDescription}. Code: ${data.errorCode}`);
}

function submitbtnCallbackForFreeMoney(bonusId) {
	actions.viewBonus({
		confirmed: true
	});

	redeemFreeMoneyBonusFromDepositFlow(bonusId);
}

function redeemFreeMoneyBonusFromDepositFlow(bonusId) {
	const redeemFreeMoneyBonusUrl = '/bonus/redeemfreemoneybonus';
	const params = {
		value: bonusId
	};
	function successHandler(data) {
		if (data.status === 'SUCCESS') {
			const result = JSON.parse(data.result);
			notifications.showInformationMessage('success', result.headerText, result.message, null, -1);
			actions.reloadBonusesAfterFreeMoneyBonusSuccess();
		}
		if (data.status === 'FAILURE') {
			handleBonusRedeemFailure(data, bonusId);
		}
		viewSubmitbtn.showSpinner(false);
	}
	function failHandler(err) {
		console.error(err);
		viewSubmitbtn.showSpinner(false);
	}

	viewSubmitbtn.showSpinner(true);
	core.post(redeemFreeMoneyBonusUrl, JSON.stringify(params), successHandler, failHandler, 'application/json; charset=UTF-8');
}

function clickBonusHandler(e) {
	function cb(p) {
		const bonusid = p.elm.getAttribute('bonusid');
		const paymentMethods = p.elm.getElementsByClassName('payment-methods')[0].getAttribute('value');
		p.e.stopPropagation();
		p.e.preventDefault();
		actions.viewBonus({
			selected: bonusid,
			paymentMethods: (paymentMethods || 'ALL'),
			confirmed: false
		});
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, '.js-event-filter', cb, true);
}

function submitbtnCallbackForDeposit(bonusId) {
	/* the callbackOnConfirm is used by router.js to enter next step */

	const isDepositOK = '/bonus/isDepositBonusOK';

	function successHandler(data) {
		if (data.status === 'SUCCESS') {
			callbackOnConfirm();
			actions.viewBonus({
				confirmed: true
			});
		} else if (data.status === 'FAILURE') {
			handleBonusRedeemFailure(data, bonusId);
		}
		viewSubmitbtn.showSpinner(false);
	}

	function failHandler() {
		viewSubmitbtn.showSpinner(false);
	}

	viewSubmitbtn.showSpinner(true);
	core.get(isDepositOK, successHandler, failHandler);
}

function addListeners() {
	core.addListener(elements.wrap, 'click', clickBonusHandler);
}

function removeListeners() {
	/* the core.removeListener-method allows the method to be used also if the elements.wrap is not there or the handler which prevents errors thrown. */
	core.removeListener(elements.wrap, 'click', clickBonusHandler);
}

function assembleStaticElements() {
	elements.contentwrapper = (elements.contentwrapper || createContentWrap());
	elements.wrap.appendChild(elements.contentwrapper);
	elements.wrapsubmit = (elements.wrapsubmit || createWrapSubmit());
	elements.wrap.appendChild(elements.wrapsubmit);
	elements.assembledStatic = true;
}

function assembleDynamicElements(p) {
	const bonusElements = [];
	const temp = {
		temp_checkmarkwrapper: null,
		temp_bonusimagewrapper: null,
		temp_bonusimage: null,
		temp_bonustextwrapper: null,
		temp_maintitle: null,
		temp_offertag: null,
		temp_bonusLink: null,
		temp_bonus: null,
		temp_bonustypetitle: null,
		temp_paymentmethods: null
	};
	/* Loop through bonus-data and create a bonus-element for each property. */
	elements.bonusesref = (elements.bonusesref || []);
	Object.keys(p).forEach((key) => {
		temp.temp_bonus = createBonus(p[key].id);
		temp.temp_bonus.setAttribute('bonusType', p[key].bonusType);
		temp.temp_bonusimagewrapper = createBonusImagewrapper();
		temp.temp_checkmarkwrapper = createCheckmarkWrapper();
		temp.temp_bonusimagewrapperInner = createBonusImagewrapperInner();
		/* save a reference */
		elements.bonusesref[p[key].id] = temp.temp_bonus;
		elements.bonusesref[p[key].id].selected = false;
		/* create all elements */
		temp.temp_bonusLink = createBonusLink();
		temp.temp_bonusimage = createBonusImage(p[key].resourceURL);
		temp.temp_bonustextwrapper = createBonusTextwrapper(p[key].description, p[key].text);
		temp.temp_maintitle = createMaintitle(p[key].header);
		temp.temp_offertag = createOffertag();
		temp.temp_bonustypetitle = createBonustypeTitle(p[key].textBonusType);
		temp.temp_paymentmethods = createHiddenPaymentMethodsField(p[key].paymentMethodIdsStr);
		/* arrange hierarchy */
		temp.temp_bonusimagewrapperInner.insertBefore(temp.temp_checkmarkwrapper, temp.temp_bonusimagewrapperInner.firstChild);
		temp.temp_bonusimagewrapper.appendChild(temp.temp_bonusimagewrapperInner);
		temp.temp_bonusimagewrapperInner.appendChild(temp.temp_checkmarkwrapper);
		temp.temp_bonusimagewrapper.appendChild(temp.temp_bonustextwrapper);
		temp.temp_bonusimagewrapperInner.appendChild(temp.temp_bonusimage);
		temp.temp_bonusLink.appendChild(temp.temp_bonusimagewrapper);
		temp.temp_bonustextwrapper.appendChild(temp.temp_offertag);
		temp.temp_bonustextwrapper.appendChild(temp.temp_bonustypetitle);
		temp.temp_bonustextwrapper.appendChild(temp.temp_maintitle);
		temp.temp_bonus.appendChild(temp.temp_bonusLink);
		temp.temp_bonus.appendChild(temp.temp_paymentmethods);
		bonusElements.push(temp.temp_bonus);
		/* delete temporary elements */
		Object.keys(temp).forEach((tempKey) => {
			temp[tempKey] = null;
		});
	});
	/* add the bonus elements to a document fragment, and insert into the wrapper */
	/* save a reference to the bonus in the elements.bonus array to prepare for cleaning the module */
	elements.bonuses = nodetree(bonusElements);
	elements.contentwrapper.appendChild(elements.bonuses);
	elements.assembledDynamic = true;
}

function createEmptyMsgWrap(txt) {
	const elm = create({
		type: 'h2',
		class: 'deposit__content-msgwrap grid-u-sm-1 u-p1 u-text-c'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function showMsgIfEmpty(isEmpty) {
	const emptylistTextkey = (textkeysObj['bonus-emptylist-feedback'] || 'textkey-missing-bonus-emptylist-feedback');
	if (isEmpty) {
		elements.emptymsgwrap = (elements.emptymsgwrap || createEmptyMsgWrap(emptylistTextkey));
		elements.wrap.appendChild(elements.emptymsgwrap);
	} else if (!isEmpty && elements.emptymsgwrap) {
		core.deleteElement(elements.emptymsgwrap, 'view_bonus:361');
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	elements = core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view_bonus:405');
	elements.assembled = false;
	elements.assembledStatic = false;
	elements.assembledDynamic = false;
}

export default {
	init(p) {
		callbackOnConfirm = (p.callbackOnConfirm || null);
		/* clean the area if necessary after skipping back and forth in the depositflow */
		deleteAllElements();
		/* Validate input */
		/* store reference to wrapper */
		/* test module and dependencies for basic requirements */
		/* attach listeners to the wrapper and use bubbling to catch events making it possible to create new child elements without loosing the handlers. */
		elements.wrap = core.getElementIfValid(p, 'wrap', 'view_bonus:368');
		textkeysObj = viewTextkeys.depositflow();
		assembleStaticElements();
		viewSubmitbtn.init({
			wrap: elements.wrapsubmit,
			buttonText: textkeysObj['bonus-continue'],
			cb: submitbtnCallbackForDeposit
		});
		viewSubmitbtn.hide();
		addListeners();
	},
	update(state) {
		/* Build dom-nodes if not already done. */
		/* View.js selects which view_sub.js that shall be updated. The sub_module also checks that this connection is set.
		The state is recieved and send unmodified to the selected views. */
		const selectedId = (state && (state.bonuses.selected && state.bonuses.selected.id));
		const listOfBonuses = (state && (state.bonuses && state.bonuses.by_id));
		const deselectedBonus = Boolean(selectedId && selectedId === -1); // gets value when toggeling a bonus from select to unselect
		const selectedBonus = ((selectedId && listOfBonuses) && listOfBonuses[selectedId]);
		const bonusType = (selectedBonus && selectedBonus.bonusType);
		const isFreeMoneyBonus = Boolean(bonusType === 'FreeMoneyBonus');
		if (listOfBonuses) {
			if (elements.assembledStatic && !elements.assembledDynamic) {
				assembleDynamicElements(state.bonuses.by_id);
			} else if (!elements.assembledStatic && !elements.assembledDynamic) {
				assembleStaticElements();
				assembleDynamicElements(state.bonuses.by_id);
			}
		}

		if (deselectedBonus) {
			/* if a bonus is selected, then show the button to continue, and mark the selected */
			viewSubmitbtn.hide();
			toggleSelectClass(selectedId); // is this necessary?
		} else if (isFreeMoneyBonus) {
			viewSubmitbtn.changeText(textkeysObj['bonus-claim']);
			const callback = function cb() {
				submitbtnCallbackForFreeMoney(selectedId);
			};
			viewSubmitbtn.init({
				wrap: elements.wrapsubmit,
				buttonText: textkeysObj['bonus-claim'],
				cb: callback
			});
			viewSubmitbtn.show();
			toggleSelectClass(selectedId);
		} else if (selectedId) {
			viewSubmitbtn.changeText(textkeysObj['bonus-continue']);
			const callback = function cb() {
				submitbtnCallbackForDeposit(selectedId);
			};
			viewSubmitbtn.init({
				wrap: elements.wrapsubmit,
				buttonText: textkeysObj['bonus-continue'],
				cb: callback
			});
			viewSubmitbtn.show();
			toggleSelectClass(selectedId);
		}
		showMsgIfEmpty(state.empty);
	},
	updateFreeMoneyBonusSuccess(state) {
		/* Special handling for free money bonus in registration flow */
		deleteAllElements();
		assembleStaticElements();
		const callback = function cb() {
			submitbtnCallbackForFreeMoney(state.bonuses.selected.id);
		};
		viewSubmitbtn.init({
			wrap: elements.wrapsubmit,
			buttonText: textkeysObj['bonus-continue'],
			cb: callback
		});
		viewSubmitbtn.hide();
		assembleDynamicElements(state.bonuses.by_id);
		addListeners();
	},
	close() {
		removeListeners();
		viewSubmitbtn.close();
		deleteAllElements();
	},
	submitbtnCallbackForFreeMoney,
	submitbtnCallbackForDeposit
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/bonus/lib/view-bonus.js